export const objectToOption=( {obj, valueKey = 'id', textKey = 'nombre' })=>{
  const option={}
  option["text"]=obj[textKey]
  option["value"]=obj[valueKey]
  return option
}